<script setup lang="ts">
const localePath = useLocalePath()

import { useRouter } from 'vue-router'

const router = useRouter()
// Fonction pour ajouter la classe router-link-active sur les pages enfants du menu
function urlStartWith(startUrl: string) {
  return router.currentRoute.value.fullPath.startsWith(startUrl)
}
</script>

<template>
  <div class="sidebar left">
    <div class="menuCss4">
      <ul class="MenuBar MenuBarActive">
        <li class="item29 selected first last rank0 parent">
          <NuxtLink :to="localePath('investorRelations-investorRelations')">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 320 512">
                <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
              </svg>
            </span>
            <span>
              {{ $t('navigation.investorRelations.name') }}
            </span>
          </NuxtLink>
          <div class="itemChildDiv29 selected">
            <ul class="itemChild29 selected">
              <li class="item14 first rank0">
                <NuxtLink :to="localePath('investorRelations-financialDocuments-quarterlyReports')" :class="{ 'selected': urlStartWith($t('navigation.financialDocuments.urlBase')) }">
                  {{ $t('navigation.financialDocuments.name') }}
                </NuxtLink>
                <div class="itemChildDiv36 selected">
                  <ul class="itemChild36 selected">
                    <li class="item60 first rank0">
                      <NuxtLink :to="localePath('investorRelations-financialDocuments-quarterlyReports')">
                        {{ $t('navigation.quarterlyReports.name') }}
                      </NuxtLink>
                    </li>
                    <li class="item37 rank1">
                      <NuxtLink :to="localePath('investorRelations-financialDocuments-annualReports')">
                        {{ $t('navigation.annualReports.name') }}
                      </NuxtLink>
                    </li>
                    <li class="item38 rank2">
                      <NuxtLink :to="localePath('investorRelations-financialDocuments-presentationsWebcasts')">
                        {{ $t('navigation.presentationsWebcasts.name') }}
                      </NuxtLink>
                    </li>
                    <li class="item39 rank3">
                      <NuxtLink :to="localePath('investorRelations-financialDocuments-managementProxyCirculars')">
                        {{ $t('navigation.managementProxyCirculars.name') }}
                      </NuxtLink>
                    </li>
                    <li class="item40 last rank4">
                      <NuxtLink :to="localePath('investorRelations-financialDocuments-annualInformationForms')">
                        {{ $t('navigation.annualInformationForms.name') }}
                      </NuxtLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="item14 first rank0">
                <NuxtLink :to="localePath('investorRelations-shareholderInformation')" :class="{ 'selected': urlStartWith($t('navigation.shareholderInformation.url')) }">
                  {{ $t('navigation.shareholderInformation.name') }}
                </NuxtLink>
                <div class="itemChildDiv36 selected">
                  <ul class="itemChild36 selected">
                    <li class="item60 first rank0">
                      <NuxtLink :to="localePath('investorRelations-stockChart')">
                        {{ $t('navigation.stockChart.name') }}
                      </NuxtLink>
                    </li>
                    <li class="item37 rank1">
                      <NuxtLink :to="localePath('investorRelations-dividendDripPolicies')">
                        {{ $t('navigation.dividendDripPolicies.name') }}
                      </NuxtLink>
                    </li>
                    <li class="item38 rank2">
                      <NuxtLink :to="localePath('investorRelations-transfertAgentAuditor')">
                        {{ $t('navigation.transfertAgentAuditor.name') }}
                      </NuxtLink>
                    </li>
                    <li class="item39 rank3">
                      <NuxtLink :to="localePath('investorRelations-faq')">
                        {{ $t('navigation.faq.name') }}
                      </NuxtLink>
                    </li>
                    <li class="item40 last rank4">
                      <NuxtLink :to="localePath('investorRelations-irContact')">
                        {{ $t('navigation.irContact.name') }}
                      </NuxtLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="item15 rank1">
                <NuxtLink :to="localePath('investorRelations-corporateGovernance')" :class="{ 'selected': urlStartWith($t('navigation.governanceCommitteeCharter.url')) }">
                  {{ $t('navigation.corporateGovernance.name') }}
                </NuxtLink>
                <div>
                  <ul class="itemChild42">
                    <li class="item71 first last rank0">
                      <NuxtLink :to="localePath('investorRelations-governanceCommitteeCharter')">
                        {{ $t('navigation.governanceCommitteeCharter.name') }}
                      </NuxtLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="item12 last rank2">
                <NuxtLink :to="localePath('investorRelations-emailAlerts')">
                  {{ $t('navigation.emailAlerts.name') }}
                </NuxtLink>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss"></style>
